module.exports = __webpack_public_path__ + "static/img/qilin_logo.fe4f30b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qilin_logo.png
// module id = 1Of7
// module chunks = 41